import { spec, validators } from 'utils/validation'
import { combine } from 'react-hooks-combine'
import { withFormModel } from 'shared/hooks'
import { withRouter } from 'react-router'

import LoginFormComponent from './component'

const { string, any } = validators

export default combine({
  hocs: [withRouter],
  hooks: [
    withFormModel(
      {
        email: spec.flow(
          string.isString,
          string.isNotEmpty,
          string.isEmail,
          any.required
        ),

        password: spec.flow(string.isString, string.isNotEmpty, any.required),
      },
      { id: 'login-form' }
    ),
  ],
})(LoginFormComponent)
